import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../authentication/AuthProvider';
import { routes } from '../routes/routes';

export function DashboardGuard() {
  let location = useLocation();
  const auth = useAuth();

  return auth?.user ? (
    <Outlet />
  ) : (
    <Navigate to={routes?.unAuthorized.match} state={{ from: location }} replace />
  );
}
